module.exports = __webpack_public_path__ + "img/logo.08fa27f7.jpg";